import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogAssignComponent } from '../assign/dialog.component.assign';
import { IVehicles, IVehiclesResponse } from '../../vehicles/veh.interfaces';

import { StripHtmlPipe } from '../../pipes/stripHTMLpipe';
import { DatePipe } from '@angular/common';
import { VehService } from '../../services/vehicles/veh.service';
import { OwnService } from '../../services/owners/own.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-data',
  templateUrl: './dialog.component.veh.html',
  styleUrls: [ './dialog.component.veh.scss' ],
  providers: [ DatePipe, VehService, OwnService ]
})

export class DialogVehicles {
  private vehModel: IVehicles = {
      'plate': 'NEW',
      'category': '',
      'manufacturer': '',
      'model': '',
      'year_manufacture': null,
      'colour': '',
      'fuel': '',
      'engine': '',
      'vin': '',
      'engine_num': '',
      'battery_num': '',
      'subcategory': '',
      'cc': '',
      'wheels_num': '',
      'passenger_num': '',
      'length':''
  };
  private plate: string;
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editVehicleData: IVehicles;
  
  public categories: any[];
  public subcategories: any[];
  public filteredSubcategories: any[] = [];
  public manufacturers: any[];
  public plateList: any[];
  public vinList: any[];
  public models: any[];
  public colors: any[];
  public fuels: any[];
  
  public userInfo: any = {};
  public filterStates(val: string) {
  }

  constructor(private datePipe: DatePipe, public dialog:MatDialog, public dialogRef: MatDialogRef<DialogVehicles>, @Inject(MAT_DIALOG_DATA) public data: any, public ownService: OwnService, public vehService: VehService){ 
   this.editVehicleData =  data.dades;

   this.vehService.getAutocomplete("category").subscribe(result => {this.categories = result;});
   this.vehService.getAutocomplete("subcategory").subscribe(result => {this.subcategories = result;});
   this.vehService.getAutocomplete("manufacturer").subscribe(result => {this.manufacturers = result;});
   this.vehService.getAutocomplete("plate").subscribe(result => {this.plateList = result;});
   this.vehService.getAutocomplete("vin").subscribe(result => {this.vinList = result;});
   this.vehService.getAutocomplete("color").subscribe(result => {this.colors = result;});
   this.vehService.getAutocomplete("fuel").subscribe(result => {this.fuels = result;});

   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");

   this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editVehicleData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    if(event){
      this.plate = event.value;
    }
  }

  setAny(event, picker) {
    this.data.setFullYear(event.year());
    picker.close();
  }

  public assignOwners(plate: string): void {
    this.vehService.getByVehicle(plate).subscribe(data => {
      const dialogRef = this.dialog.open(DialogAssignComponent, {
        width: '500px',    
        data: {
          mode: 'vehicle-to-owner',
          id: plate,
          currentAssignments: data
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) return;
        this.vehService.setOwnersForVehicle(plate, result).subscribe();
      });
    });
  }

  ngOnInit(){ }

  categoryChanged(categoryValue: string) {
    this.editVehicleData.subcategory = '';
    const cat = this.categories.find(c => c.value === categoryValue);
    if (!cat) {
        this.filteredSubcategories = [];
        return;
    }

    this.filteredSubcategories = this.subcategories.filter(s => s.type === cat.type);

  }
}
